export default __webpack_public_path__ + "static/media/Pot2.289cfb92.svg";